import React, { useState } from "react";
import { Box, Chip, CircularProgress, IconButton, TextField, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { updatePowerCustomerTags } from "../../services/powerCustomer";
import { toastMessage } from "../../utils/toastMessage";

const UserTagEditor = ({ userId, tags = [], onChange }) => {
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async (nextTags) => {
    try {
      setSaving(true);
      const record = await updatePowerCustomerTags(userId, nextTags);
      onChange?.(record.tags || []);
    } catch (error) {
      toastMessage(error.message || "Unable to update tags", "error");
    } finally {
      setSaving(false);
    }
  };
  const add = () => {
    const value = draft.trim();
    if (!value) return;
    setDraft("");
    save([...new Set([...tags, value])]);
  };

  return (
    <Box sx={{ minWidth: 220 }}>
      <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mb: 0.75 }}>
        {tags.map((tag) => <Chip key={tag} size="small" label={tag}
          onDelete={() => save(tags.filter((value) => value !== tag))} disabled={saving} />)}
      </Box>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        <TextField size="small" placeholder="Add tag" value={draft}
          inputProps={{ maxLength: 40 }} onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => { if (event.key === "Enter") { event.preventDefault(); add(); } }} />
        <Tooltip title="Add tag"><span><IconButton size="small" onClick={add} disabled={saving || !draft.trim()}>
          {saving ? <CircularProgress size={18} /> : <AddIcon />}
        </IconButton></span></Tooltip>
      </Box>
    </Box>
  );
};

export default UserTagEditor;
